<header class="bg-gray-800 h-16 shadow-lg flex items-center px-4">
  <!-- Contenedor de botones alineados a la derecha -->
  <div class="ml-auto flex space-x-2">
    <!-- 
    <p-button type="button" (onClick)="fnToggleDarkMode()" 
              icon="{{ isDarkMode ? 'pi pi-moon' : 'pi pi-sun' }}" 
              class="p-button-topbar bg-gray-800 " />
    -->
    <p-button type="button" icon="pi pi-user" class="p-button-topbar bg-gray-900 " />
    <p-button type="button" (onClick)="fnCerrarSesion()" 
              icon="pi pi-sign-out" class="p-button-topbar bg-gray-900 " />
  </div>
</header>